/**
 * Configurações padrão para os componentes do site
 */

new Swiper('.simple-carousel', {
  slidesPerView: 1,
  spaceBetween: 10,
  pagination: {
    el: `.simple-carousel__pagination`,
    clickable: true,
  },
  breakpoints: {
    1441: {
      slidesPerView: 4,
      centeredSlides: false,
      spaceBetween: 20,
    },
    1200: {
      slidesPerView: 3,
      centeredSlides: false,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2,
      centeredSlides: false,
      spaceBetween: 20,
    }
  }
});